<template>
    <layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Users">
        <div class="grid grid-cols-1 items-center justify-center p-8 pb-0">
            <div class="col-span-1 sm:col-span-1 text-right">
                <jet-input id="query" type="text" class="w-full sm:w-auto mt-2 ml-0 sm:ml-4 sm:mt-0" v-model="searchForm.query" autocomplete="query" placeholder="Start typing to search..." @keyup="search()" />
            </div>
        </div>

        <div class="sm:p-6">
			<div class="py-4">
	        	<tw-table :headers="headers" :items="users.data">
                    <template #footer>
						<pagination class="mt-6" :data="users" />

                        <div class="p-4 flex justify-end bg-white border-t border-gray-100 transition duration-500 ease-in-out dark:bg-gray-900 dark:border-gray-800">
                            <tw-button class="ml-4" @click="newUserModalOpen = true">Create User</tw-button>
                        </div>
                    </template>
	        	</tw-table>
	        </div>
	    </div>

        <tw-modal width="600" :show="newUserModalOpen" @close="newUserModalOpen = false" title="Create New User">
            <jet-form-section @submitted="storeUser">
                <template #form>
                	<div class="grid grid-cols-2 gap-4">
                		<div class="col-span-1">
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="first_name" value="First Name" />
		                        <jet-input :ignore-dark-mode="true" name="first_name" v-model="createForm.first_name" placeholder="Enter Your First Name" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.first_name" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.first_name" class="mt-2" />
		                    </div>
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="last_name" value="Last Name" />
		                        <jet-input :ignore-dark-mode="true" name="last_name" v-model="createForm.last_name" placeholder="Enter Your Last Name" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.last_name" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.last_name" class="mt-2" />
		                    </div>
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="date_of_birth" value="Date of Birth" />
		                        <jet-input :ignore-dark-mode="true" name="date_of_birth" v-model="createForm.date_of_birth" placeholder="Enter Your Date of Birth" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.date_of_birth" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.date_of_birth" class="mt-2" />
		                    </div>
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="username" value="Username" />
		                        <jet-input :ignore-dark-mode="true" name="username" v-model="createForm.username" placeholder="Enter Your Username" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.username" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.username" class="mt-2" />
		                    </div>
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="email" value="Email" />
		                        <jet-input type="email" :ignore-dark-mode="true" name="email" v-model="createForm.email" placeholder="Enter Your Email" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.email" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.email" class="mt-2" />
		                    </div>
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="mobile" value="Mobile" />
		                        <jet-input type="tel" :ignore-dark-mode="true" name="mobile" v-model="createForm.mobile" placeholder="Enter Your Mobile" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.mobile" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.mobile" class="mt-2" />
		                    </div>
		                </div>

                		<div class="col-span-1">
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="building" value="Building" />
		                        <jet-input :ignore-dark-mode="true" name="building" v-model="createForm.building" placeholder="Enter Your Building" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.building" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.building" class="mt-2" />
		                    </div>
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="street" value="Street" />
		                        <jet-input :ignore-dark-mode="true" name="street" v-model="createForm.street" placeholder="Enter Your Street" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.street" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.street" class="mt-2" />
		                    </div>
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="city" value="City" />
		                        <jet-input :ignore-dark-mode="true" name="city" v-model="createForm.city" placeholder="Enter Your City" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.city" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.city" class="mt-2" />
		                    </div>
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="postcode" value="Postcode" />
		                        <jet-input :ignore-dark-mode="true" name="postcode" v-model="createForm.postcode" placeholder="Enter Your Postcode" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.postcode" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.postcode" class="mt-2" />
		                    </div>
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="password" value="Password" />
		                        <jet-input type="password" :ignore-dark-mode="true" name="password" v-model="createForm.password" placeholder="Enter Your Password" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.password" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.password" class="mt-2" />
		                    </div>
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
		                        <jet-label for="password_confirmation" value="Confirm Password" />
		                        <jet-input type="password" :ignore-dark-mode="true" name="password_confirmation" v-model="createForm.password_confirmation" placeholder="Confirm Password" class="mt-1 block w-full p-2" />
		                        <div v-show="createForm.errors.password_confirmation" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
		                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
		                        </div>
		                        <jet-input-error :message="createForm.errors.password_confirmation" class="mt-2" />
		                    </div>
		                </div>

                		<div class="col-span-2">
		                    <div class="mt-1 relative rounded-md shadow-sm mb-4 text-right">
		                        <label class="inline-block mr-2">
		                            <jet-checkbox :ignore-dark-mode="true" :value="createForm.should_ignore_checks" v-model:checked="createForm.should_ignore_checks" :error="createForm.errors.should_ignore_checks" />
		                            <span class="ml-2 text-sm text-gray-600 dark:text-white">Ignore Verification Checks?</span>
		                        </label>

		                        <label class="inline-block">
		                            <jet-checkbox :ignore-dark-mode="true" :value="createForm.is_admin" v-model:checked="createForm.is_admin" :error="createForm.errors.is_admin" />
		                            <span class="ml-2 text-sm text-gray-600 dark:text-white">Make Admin?</span>
		                        </label>
		                    </div>
		                </div>
	                </div>
                </template>

                <template #actions>
                    <jet-button class="text-right" :ignore-dark-mode="true" :class="{ 'opacity-25': createForm.processing }" :disabled="createForm.processing">
                        Save
                    </jet-button>
                </template>
            </jet-form-section>
        </tw-modal>

        <tw-modal :show="showTokenModal" @close="showTokenModal = false" title="Give Tokens">
            <jet-form-section @submitted="addTokens">
                <template #form>
                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
                        <jet-label for="play_tokens" value="Play Token Amount" />
                        <jet-input :ignore-dark-mode="true" name="play_tokens" v-model="updateForm.play_tokens" placeholder="Enter Your Play Token Amount" class="mt-1 block w-full p-2" />
                        <div v-show="updateForm.errors.play_tokens" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                        </div>
                        <jet-input-error :message="updateForm.errors.play_tokens" class="mt-2" />
                    </div>
                </template>

                <template #actions>
                    <jet-button class="text-right" :ignore-dark-mode="true" :class="{ 'opacity-25': updateForm.processing }" :disabled="updateForm.processing">
                        Give Tokens
                    </jet-button>
                </template>
            </jet-form-section>
        </tw-modal>

        <tw-modal :show="showDeleteConfirmModal" @close="showDeleteConfirmModal = false" title="Delete User?">
            <jet-form-section @submitted="deleteUser">
                <template #form>
                    <div v-if="showDeleteConfirmModal" class="mt-1 relative rounded-md shadow-sm mb-4">
                        Are you sure you want to delete the user {{ selectedUser.first_name }} {{ selectedUser.last_name }}?
                    </div>
                </template>

                <template #actions>
                    <jet-button type="button" class="text-right mr-2" :ignore-dark-mode="true" @click="showDeleteConfirmModal = false">
                        Cancel
                    </jet-button>
                    <jet-button :ignore-dark-mode="true" class="bg-red-700 text-gray-100 dark:bg-red-700 dark:text-gray-100">
                        Confirm
                    </jet-button>
                </template>
            </jet-form-section>
        </tw-modal>

        <tw-modal :show="showBanUserConfirmationModal" @close="showBanUserConfirmationModal = false" title="Ban User?">
            <jet-form-section @submitted="banUser">
                <template #form>
                    <div v-if="showBanUserConfirmationModal" class="mt-1 relative rounded-md shadow-sm mb-4">
                        Are you sure you want to ban the user user {{ selectedUser.first_name }} {{ selectedUser.last_name }}?
                    </div>
                </template>

                <template #actions>
                    <jet-button type="button" class="text-right mr-2" :ignore-dark-mode="true" @click="showBanUserConfirmationModal = false">
                        Cancel
                    </jet-button>
                    <jet-button :ignore-dark-mode="true" class="bg-red-700 text-gray-100 dark:bg-red-700 dark:text-gray-100">
                        Confirm
                    </jet-button>
                </template>
            </jet-form-section>
        </tw-modal>
    </layout>
</template>

<script>
	import { ref, reactive, getCurrentInstance, onMounted, computed } from 'vue'
	import TwTable from '@/Global/Elements/TwTable'
	import TwButton from '@/Global/Elements/TwButton'
	import JetInput from '@/Jetstream/Input.vue'
	import JetTextarea from '@/Jetstream/Textarea.vue'
	import JetCheckbox from '@/Jetstream/Checkbox.vue'
	import JetInputError from '@/Jetstream/InputError.vue'
	import JetButton from '@/Jetstream/Button.vue'
	import JetLabel from '@/Jetstream/Label.vue'
	import JetFormSection from '@/Jetstream/FormSection.vue'
	import TwModal from '@/Global/Elements/TwModal.vue'
	import { ExclamationCircleIcon } from '@heroicons/vue/solid'
	import { XCircleIcon, DatabaseIcon, UserRemoveIcon, UserIcon } from '@heroicons/vue/outline'
	import Layout from '@/Layouts/Layout'
	import Pagination from '@/Global/Pagination'
	import { Head, Link } from '@inertiajs/inertia-vue3';
	import { Inertia } from '@inertiajs/inertia'

	export default {
		props: {
			users: Object,
		},
		components: {
			Layout,
			TwTable,
			TwButton,
	        JetInput,
	        JetTextarea,
	        JetCheckbox,
	        JetInputError,
	        JetButton,
	        JetLabel,
	        JetFormSection,
	        TwModal,
	        ExclamationCircleIcon,
	        XCircleIcon,
	        DatabaseIcon,
	        UserRemoveIcon,
	        UserIcon,
			Pagination,
        	Link,
		},
		setup() {
	        const createForm = Inertia.form({
	            first_name: null,
	            last_name: null,
	            date_of_birth: null,
	            username: null,
	            email: null,
	            mobile: null,
	            building: null,
	            street: null,
	            city: null,
	            postcode: null,
	            country_id: 169,
	            password: null,
	            password_confirmation: null,
	            should_ignore_checks: false,
	            is_admin: false,
	        })

	        const updateForm = Inertia.form({
	            action: null,
	            play_tokens: null,
	        })

	        const searchForm = Inertia.form({
	            query: '',
	        })

			const newUserModalOpen = ref(false)
			const showTokenModal = ref(false)
			const showDeleteConfirmModal = ref(false)
			const showBanUserConfirmationModal = ref(false)
			const selectedUser = ref(null)

            const search = () => {
                searchForm.post(route('admin.users.search'), {
                    onSuccess: res => {
                        //
                    }
                })
            }

	        const storeUser = () => {
	        	createForm.post(route('admin.users.store'), {
	        		onSuccess: () => {
	        			createForm.reset()
	        			newUserModalOpen.value = false
	        		}
	        	})
	        }

	        const deleteUser = () => {
	        	if (selectedUser.value) {
		        	Inertia.delete(route('admin.users.destroy', { id: selectedUser.value.id }), {
		        		onSuccess: () => {
		        			showDeleteConfirmModal.value = false
		        			selectedUser.value = null
		        		}
		        	})
		        }
	        }

	        const banUser = () => {
	        	if (selectedUser.value) {
		        	updateForm
		        		.transform((data) => ({
                            ...data,
		        			action: 'banUser',
		        		}))
			        	.patch(route('admin.users.update', { id: selectedUser.value.id }), {
			        		onSuccess: () => {
			        			updateForm.reset()
			        			showBanUserConfirmationModal.value = false
			        			selectedUser.value = null
			        		}
			        	})
		        }
	        }

	        const addTokens = () => {
	        	if (selectedUser.value) {
		        	updateForm
		        		.transform((data) => ({
                            ...data,
		        			action: 'addTokens',
		        		}))
		        		.patch(route('admin.users.update', { id: selectedUser.value.id }), {
			        		onSuccess: () => {
			        			updateForm.reset()
			        			showTokenModal.value = false
			        			selectedUser.value = null
			        		}
			        	})
		        }
	        }

			const headers = [
                { text: 'ID', value: 'id' },
                { text: '', value: 'profile_photo_path' },
                { text: 'First Name', value: 'first_name' },
                { text: 'last Name', value: 'last_name' },
                { text: 'Username', value: 'username' },
                { text: 'Email', value: 'email' },
                { text: '', value: [
                	{
                		name: 'Give Tokens',
                		icon: DatabaseIcon,
                		action: 'updateTokens',
                		disabled: false,
                		showText: true,
                		class: '',
                		method: (item) => {
                			selectedUser.value = item
                			showTokenModal.value = true
                		}
                	},
                	{
                		name: 'Delete User',
                		icon: XCircleIcon,
                		action: 'delete',
                		disabled: false,
                		showText: false,
                		class: 'bg-red-700 text-gray-100 dark:bg-red-700 dark:text-gray-100',
                		method: (item) => {
                			selectedUser.value = item
                			showDeleteConfirmModal.value = true
                		}
                	},
                	{
                		name: 'Ban User',
                		icon: UserRemoveIcon,
                		action: 'ban',
                		showText: false,
                		class: '',
                		method: (item) => {
                			selectedUser.value = item
                			showBanUserConfirmationModal.value = true
                		}
                	},
                	{
                		name: 'View User Details',
                		icon: UserIcon,
                		action: 'view',
                		showText: false,
                		class: '',
                		method: (item) => {
                			selectedUser.value = item

                			Inertia.visit(route('admin.users.show', { id: item.id }))
                		}
                	}
                ]},
            ]

            return {
            	newUserModalOpen,
            	showTokenModal,
            	showDeleteConfirmModal,
            	showBanUserConfirmationModal,
            	addTokens,
            	deleteUser,
            	banUser,
            	selectedUser,
            	createForm,
            	updateForm,
            	storeUser,
            	headers,
            	searchForm,
            	search,
            }

		}
	}
</script>
